<body class="style_3">
    <div class="wrapper_centering" style="margin:0">
        <div class="container_centering">
            <div class="container">
                <div class="row justify-content-between">
                    <h3>
                        <!-- <img src="{{clientlogo}}{{logoimage}}" alt="Logo" style="margin-top: -235px;">  -->
                    </h3>
                    <div class="col-xl-12 ">
                        <div class="main_title_1 text-center">
                          
                            <div *ngIf = "status==1" >
                                <p>Thank you for participating in our survey.<br/> You have successfully completed this study, we greatly appreciate your time and effort.</p>
                            </div>
                            <div *ngIf = "status==2" >
                                <p>Thank you for participating in our survey.<br/> Unfortunately, based on your responses, it appears that you do not meet the criteria for this particular survey.</p>
                            </div>
                            <div *ngIf = "status==3" >
                                <p>Thank you for participating in our survey.<br/> Unfortunately, we have reached the maximum number of responses needed at this time.</p>
                            </div>
                            <div *ngIf = "status==4" >
                                <p>Thank you for participating in our survey.<br/> Unfortunately, based on your responses, it appears that you do not meet the quality criteria for this particular survey.</p>
                            </div>
                            <div *ngIf = "status==5" >
                                <p>Thank you for participating in our survey.<br/> We have reached maximum responses for this study and survey is closed currently.</p>
                            </div>
                          
                        </div>
                    </div>
                    <!-- /col -->
                </div>
            </div>
            <!-- /row -->
        </div>
        <!-- /container_centering -->
    </div>
    <!-- /wrapper_centering -->
</body>